<template>
  <div class="login">
    <div class="head">
      <div class="img">
        <img src="../assets/img/head.png" />
      </div>
      <p>方心科技移动缴费系统</p>
    </div>
    <div class="register">
      没有账号？<font @click="$router.push('/register')">立即注册</font>
    </div>
    <!--登陆-->
    <form action="javascript:;">
      <div class="item">
        <input
          type="text"
          name="name"
          v-model="login.phoneNum"
          placeholder="请输入您的帐号"
          autocomplete="off"
          class="name"
        />
      </div>
      <div class="item">
        <input
          type="password"
          name="password"
          v-model="login.password"
          placeholder="请输入您的密码"
          autocomplete="off"
          class="password"
        />
      </div>
      <div class="forget">
        <div class="remember">
          <wd-checkbox
            v-model="remember"
            shape="square"
            style="margin-left: 5px"
            ><font style="color: #3c3c3c;">记住密码</font></wd-checkbox
          >
        </div>
        <div class="for" @click="$router.push('/forget')">忘记密码？</div>
      </div>
      <div class="submit" @click="doLogin">
        <button
          :disabled="disabled"
          v-if="disabled"
          style="background-color: #666666"
        >
          登陆中</button
        ><button v-else :disabled="disabled">
          登&nbsp;&nbsp;&nbsp;&nbsp;陆
        </button>
      </div>
    </form>
    <!--尾部-->
    <div class="footer">
      <!--      <img src="../assets/img/logo.png">-->
      <p>
        登录使用就表示同意用户协议<a href="javascript:;">条款</a>和<a
          href="javascript:;"
          >隐私</a
        >政策
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      disabled: false,
      login: {
        phoneNum: "",
        password: "",
      },
      remember: false,
    };
  },
  mounted() {
    if (localStorage.getItem("phoneNumRem")) {
      this.login.phoneNum = localStorage.getItem("phoneNumRem");
      this.remember = true;
    }
    if (localStorage.getItem("passwordRem")) {
      this.login.password = localStorage.getItem("passwordRem");
    }
  },
  methods: {
    doLogin() {
      if (!this.login.phoneNum || !this.login.password) {
        this.$toast("用户名或密码不能为空！");
      } else {
        this.disabled = true;
        this.$http.post("/external/appUser/login", this.login).then((res) => {
          if (res.code == 200) {
            this.$toast.success("登录成功！");
            setTimeout(() => {
              localStorage.setItem("appUserId", res.user.appUserId);
              localStorage.setItem("phoneNum", res.user.phoneNum);
              if (res.user.roleId) {
                localStorage.setItem("roleKey", res.user.roleId);
              } else {
                localStorage.removeItem("roleKey");
              }
              if (res.user.rolePhoneNum) {
                // console.log("res.user.rolePhoneNum", res.user.rolePhoneNum);
                localStorage.setItem("rolePhoneNum", res.user.rolePhoneNum);
              } else {
                localStorage.removeItem("rolePhoneNum");
              }
              if (res.user.roleIds) {
                localStorage.setItem("roleIds", res.user.roleIds);
              } else {
                localStorage.removeItem("roleIds");
              }

              if (
                res.user.roleIds &&
                res.user.roleIds.includes(res.user.roleId + "")
              ) {
                localStorage.setItem("showControl", "true");
              } else {
                localStorage.setItem("showControl", "false");
              }
              if (this.remember) {
                localStorage.setItem("phoneNumRem", this.login.phoneNum);
                localStorage.setItem("passwordRem", this.login.password);
              } else {
                localStorage.removeItem("phoneNumRem");
                localStorage.removeItem("passwordRem");
              }
              this.disabled = false;
              setTimeout(() => {
                this.$router.push("/home");
              }, 500);
            }, 1000);
          } else {
            this.disabled = false;
            this.$toast.error(res.msg);
          }
        });
      }
    },
  },
};
</script>

<style lang="less">
@iconSize: 70px;
.login {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  background: url(../assets/img/top_bg.png) top left no-repeat;
  background-size: 100%;
  .head {
    width: 100%;
    height: 20%;
    .img {
      width: @iconSize;
      height: @iconSize;
      background: #ffffff;
      border-radius: 50%;
      margin: 0 auto;
      margin-top: 10%;
      text-align: center;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    img {
      width: @iconSize - 20px;
    }
    p {
      text-align: center;
      color: #ffffff;
      font-size: 16px;
    }
  }
  .register {
    margin: 60px 20px 0 20px;
    font-size: 14px;
    text-align: right;
    color: #888;
    font {
      color: #1f6ecf;
    }
  }
  /*登陆表单*/
  form {
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 20px 20px 20px 20px;
    .item {
      display: flex;
      align-items: center;
      width: calc(100% - 40px);
      height: 40px;
      margin-bottom: 30px;
      color: #333333;
      input {
        width: 100%;
        height: 100%;
        display: inline-block;
        border: 1px solid #ebebeb;
        border-radius: 20px;
        box-shadow: 0px 0px 10px rgba(200, 200, 200, 0.1);
        padding-left: 35px;
        outline: none;
        &.name {
          background: url(../assets/img/icon-phone.png) left 15px center
            no-repeat;
          background-size: 12px auto;
        }
        &.password {
          background: url(../assets/img/icon-lock.png) left 15px center
            no-repeat;
          background-size: 12px auto;
        }
      }
    }
    .forget {
      display: flex;
      width: calc(100% - 40px);
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .remember {
        font-size: 13px;
      }
      .for {
        font-size: 13px;
        color: #1f6ecf;
      }
    }
    .submit {
      width: calc(100% - 40px);
      button {
        border: none;
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 18px;
        color: #ffffff;
        border-radius: 20px;
        outline: none;
        box-shadow: 0 5px 5px rgba(31, 110, 207, 0.2);
        display: inline-block;
        width: 100%;
        background: #1f6ecf;
      }
    }
  }
  /*尾部*/
  .footer {
    text-align: center;
    padding-top: 20px;
    p {
      font-size: 14px;
      color: #666666;
      text-align: center;
      padding: 10px 0 5px 0;
      letter-spacing: 1px;
      a {
        color: #078dda;
      }
    }
  }
}
</style>
